import { render, staticRenderFns } from "./HostedPrivacyPolicy.vue?vue&type=template&id=7dac11d6&"
import script from "./HostedPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./HostedPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HostedPrivacyPolicy.vue?vue&type=style&index=0&id=7dac11d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports